/* unplugin-vue-components disabled */import { render } from "./ScormExportDialog.vue?vue&type=template&id=4c964bfa&scoped=true&ts=true"
import script from "./ScormExportDialog.vue?vue&type=script&lang=ts"
export * from "./ScormExportDialog.vue?vue&type=script&lang=ts"

import "./ScormExportDialog.vue?vue&type=style&index=0&id=4c964bfa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c964bfa"]])

export default __exports__